import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import React, { useEffect } from 'react'
import { isNullOrUndefined } from '../../../../util/Utils'
import { PersonLink, TreePersonLink, UserLink } from '../../../app/Links'
import { TreeIdCells } from './TreeIdBlock'

export function SlaveryAssociationSummary({ messageDetails, queueCachesState, queueCachesActions }) {
  const { t } = useTranslation()
  const person1Id = messageDetails?.person1Id
  const person2Id = messageDetails?.person2Id
  const contributorId = messageDetails?.contributorId

  const person1Summary = queueCachesState.personsCache[person1Id]
  const person2Summary = queueCachesState.personsCache[person2Id]
  const userSummary = queueCachesState.usersCache[contributorId]

  useEffect(() => {
    queueCachesActions.fetchPersonSummary(person1Id)
    queueCachesActions.fetchPersonSummary(person2Id)
    queueCachesActions.fetchUserSummary(contributorId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isNullOrUndefined(person1Summary) || isNullOrUndefined(person2Summary) || isNullOrUndefined(userSummary)) {
    return null
  }

  return (
    <Grid>
      <Cell columns={6}>
        <DataBlock
          heading={t('person1Id', 'Person 1 ID')}
          data={
            <>
              <PersonLink personId={person1Id} personName={person1Summary?.summary?.name} showId newTab />
              <TreePersonLink personId={person1Id} treeIcon newTab />
            </>
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock
          heading={t('person2Id', 'Person 2 ID')}
          data={
            <>
              <PersonLink personId={person2Id} personName={person2Summary?.summary?.name} showId newTab />
              <TreePersonLink personId={person2Id} treeIcon newTab />
            </>
          }
        />
      </Cell>
      <Cell columns={12}>
        <DataBlock
          heading={t('contributor', 'Contributor')}
          data={
            <UserLink
              userId={contributorId}
              userName={userSummary?.contactName}
              country={userSummary?.country}
              showId
              newTab
            />
          }
        />
      </Cell>

      <TreeIdCells treeId={messageDetails?.treeId} isResearcherTree={messageDetails?.researcherTree} />
    </Grid>
  )
}
